import ReactModal from 'react-modal'

import { stopEvent } from 'utils/event'

import style from './index.module.scss'

const DEF_WIDTH = 'fw-min'
export function Modal({
  width = DEF_WIDTH,
  viewState: [modalOpen, setModalOpen],
  header = undefined,
  children = undefined,
  noScroll = false,
  className = '',
  wrapClass = '',
  headerClass = 'ph3 pv2 b',
  stopEvents = true,
  onAfterClose
}) {
  // TODO: in the future address ariaHideApp
  // warn msg:
  //    Warning: react-modal: App element is not defined. Please use `Modal.setAppElement(el)` or set `appElement={el}`. This is needed so screen readers don't see main content when modal is opened. It is not recommended, but you can opt-out by setting `ariaHideApp={false}`.

  width = width || DEF_WIDTH

  if (!modalOpen) return null
  return (
    <ReactModal
      isOpen={true}
      onClick={(e) => stopEvents && stopEvent(e)}
      ariaHideApp={false}
      onRequestClose={() => setModalOpen(false)}
      className={`relative ${style.modal} `}
      overlayClassName={style.overlay}
      onAfterClose={onAfterClose && onAfterClose()}
    >
      <div
        className={`base-frame shadow-6 ${style.frame} ${
          style[width]
        } ${wrapClass} ${noScroll ? '' : 'overflow-y-auto'}`}
      >
        {header ? (
          <div
            className={`bg-accent sticky top-0 z-1 flex-items ph3 ${headerClass}`}
          >
            {header}
            <button
              className={`${style.close} clear pa1 flex-center br2 hover-hilite`}
              onClick={() => setModalOpen(false)}
            >
              <i className="fas fa-times b" />
            </button>
          </div>
        ) : null}
        <div className={className ?? style.body}>{children}</div>
      </div>
    </ReactModal>
  )
}

export * from './Confirm'
export * from './Help'
export default Modal
